import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { SecurePaymentBadge } from './SecurePaymentBadge';
import { PRICE, TOTAL_VALUE, valueStack } from '../data/content';
export function ValueSection() {
  return <section className="w-full bg-ivory py-20 md:py-28" aria-labelledby="valor" data-id="element-245" data-mp="iew151ajp1rd">
      <div className="mx-auto max-w-3xl px-6 lg:px-8" data-id="element-246" data-mp="df9p2v6gdrk5">
        <SectionHeading eyebrow="Tu kit completo" title={<span id="valor" data-id="element-248" data-mp="8otah7qwbzw7">Recibe hoy tu Kit Completo de Reinicio Emocional</span>} data-id="element-247" data-mp="dgui2gd4d2fw" />

        <Reveal delay={0.08} className="mt-14" data-id="element-249" data-mp="8mq9jso7gmcp">
          <div className="rounded-[1.75rem] border border-sand bg-shell/60 px-6 py-8 sm:px-10 sm:py-11" data-id="element-250" data-mp="3qhzuuss1lcx">
            <ul data-id="element-251" data-mp="3ux2lfz02c12k">
              {valueStack.map(item => <li key={item.name} className="flex items-baseline justify-between gap-6 border-b border-sand py-5 first:pt-0" data-id="element-252" data-mp="3utwxin36758f">
                  <div data-id="element-253" data-mp="3lujnntb4wen6">
                    <p className="font-display text-lg font-light text-ink sm:text-xl" data-id="element-254" data-mp="3lwe8l7meo6r9">
                      {item.name}
                    </p>
                    <p className="mt-1 font-sans text-[0.66rem] uppercase tracking-[0.16em] text-mute" data-id="element-255" data-mp="1j80dezjiynno">
                      {item.detail}
                    </p>
                  </div>
                  <span className="shrink-0 font-sans text-[0.95rem] font-light text-warmgray" data-id="element-256" data-mp="1a7272alm641x">
                    Valor {item.value}
                  </span>
                </li>)}
            </ul>

            <div className="mt-7 flex items-baseline justify-between" data-id="element-257" data-mp="21y87yt95s5s9">
              <span className="font-sans text-[0.68rem] uppercase tracking-luxe text-mute" data-id="element-258" data-mp="26y4asp64dr68">
                Valor total
              </span>
              <span className="font-display text-2xl font-light text-warmgray line-through decoration-nude" data-id="element-259" data-mp="1xypom1wzk2rj">
                {TOTAL_VALUE}
              </span>
            </div>

            <div className="mt-8 rounded-2xl bg-ivory px-6 py-8 text-center" data-id="element-260" data-mp="hj6d3dnfiq8u">
              <p className="font-sans text-[0.62rem] uppercase tracking-luxe text-gold" data-id="element-261" data-mp="mkc85i4kaplj">
                Hoy tu inversión es
              </p>
              <p className="mt-3 font-display text-5xl font-light text-ink sm:text-6xl" data-id="element-262" data-mp="2j9n8xv408jvz">{PRICE}</p>
              <p className="mt-3 font-sans text-[0.68rem] uppercase tracking-[0.16em] text-mute" data-id="element-263" data-mp="2eix54mb88p3e">
                Pago único · Acceso inmediato · Garantía de 7 días
              </p>
              <CTAButton location="valor" className="mt-8 w-full sm:w-auto" data-id="element-264" data-mp="2af8vzz6y5lg1">
                Quiero volver a mí
              </CTAButton>
              <div className="mt-6" data-id="element-265" data-mp="20imbxcmg2yf2">
                <SecurePaymentBadge data-id="element-266" data-mp="20hkqce7sytj3" />
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}